let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5R7ig")).then(() => parcelRequire('3hP61'));